import type { BundledExperienceField } from './types';

export const BUNDLED_EXPERIENCE_FIELDS: Array<BundledExperienceField> = [];
